
/**
 * 检查范围是否合法
 */
export function rangeCheck(val, min = 1, max = 100) {
  if (!val) {
    return false;
  }
  if (/^[0-9]+$/.test(val) === false) {
    return false;
  }
  if (/^(0)\d{0,}$/.test(val)) {
    return false;
  }
  if (val < min || val > max) {
    return false;
  }
  return true;
}

export function checkRules(data = '', rules = null, type, max, min) {
  if (!data) {
    return true;
  }

  let hasError = false;

  if (type === 'RangeInput') {
    return !rangeCheck(data, min, max);
  }

  if (!rules) {
    return false;
  }

  // eslint-disable-next-line no-unused-expressions
  rules && rules.forEach((rule) => {
    if (hasError) {
      return;
    }
    if (rule.required === true && !data) {
      hasError = true;
      return;
    }
    if (rule.pattern && !rule.pattern.test(data)) {
      hasError = true;
      return;
    }
    if (rule.vfunc && !rule.vfunc(data)) {
      hasError = true;
    }
  });


  return hasError;
}
/**
 * 检查input框合法性
 */
export function checkInput(value = '', rule = null) {
  if (!value) {
    return false;
  }
  if (rule.test(value) === false) {
    return false;
  }

  return true;
}

export function getCookie(cname) {
  const name = `${cname}=`;
  const ca = document.cookie.split(';');
  // eslint-disable-next-line no-plusplus
  for (let i = 0; i < ca.length; i++) {
    const c = ca[i].trim();
    if (c.indexOf(name) === 0) return c.substring(name.length, c.length);
  }
  return '';
}
